export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5089.ef2c419a.jpg";